import React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Hero() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="18496" id="introducción-al-curso" className="relative w-full overflow-hidden bg-background text-foreground py-[120px]">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/electronics_soldering.png')] bg-cover bg-center bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-background/70 backdrop-blur-sm" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={textRef} className={cn("max-w-4xl transition-all duration-1000 ease-out backdrop-blur-md bg-white/5 p-8 md:p-12 rounded-[2rem] border border-white/10", textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          <h1 className="font-sans text-4xl font-extrabold uppercase leading-tight tracking-tight text-white drop-shadow-[0_0_15px_rgba(30,58,138,0.5)] sm:text-5xl md:text-6xl lg:text-7xl">
            TÉCNICO EN <br className="hidden md:block" />
            <span className="text-secondary">
              ELECTRÓNICA
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-lg text-gray-200 sm:text-xl md:mt-8">
            Obtené tu certificación profesional y dominá el arte de la reparación 
            y diseño de circuitos con nuestro programa intensivo. Aprendé con 
            expertos y transformá tu futuro tecnológico.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
            <Button asChild size="lg" className="bg-secondary text-secondary-foreground rounded-[24px] shadow-[0_0_20px_rgba(255,191,0,0.3)] transition-all duration-500 ease-out hover:scale-[1.02] hover:bg-secondary/90 hover:shadow-[0_0_25px_rgba(255,191,0,0.5)]">
              <Link to="https://wa.me/59896344395" newTab>
                Inscribite Ahora
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="border-white bg-transparent text-white rounded-[24px] transition-all duration-500 ease-out hover:scale-[1.02] hover:bg-white/10 hover:text-white">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}